import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetWorkerAstraUserRequestSchema,
  TGetWorkerAstraUserResponseSchema,
} from "../getWorkerAstraUser/getWorkerAstraUser.schema";

export const createWorkerAstraUser = (axios: IAxiosInstance) => {
  return async (params: TGetWorkerAstraUserRequestSchema) => {
    const { worker_id } = params;
    const { data } = await axios.noRetry.post<
      IApiResponse<TGetWorkerAstraUserResponseSchema>
    >(`/push-to-card/worker`, {
      workerID: worker_id,
    });

    return data.data;
  };
};
